// extracted by mini-css-extract-plugin
export var chevronIcon = "_e7-2";
export var teamName = "_e7-1";
export var teamSwitcherButton = "_e7-0";